$(document).ready(function() {
          
          $(".mobile_menu").simpleMobileMenu({
              onMenuLoad: function(menu) {
              const trigger = $("#sm_menu_ham");

              // ARIA-Attribute setzen
              trigger.attr({
                  role: "button",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  "aria-label": "Menü öffnen",
                  tabindex: 0
              });

              // Tastaturbedienung ermöglichen (Enter und Space)
              trigger.on("keydown", function(e) {
                  if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      $(this).trigger("click");
                  }
              });
          },

          onMenuToggle: function(menu, opened) {
              $("#sm_menu_ham").attr("aria-expanded", opened ? "true" : "false");
              if (!opened) {
                  $("#sm_menu_ham").focus();
              }
          },
              "menuStyle": "slide"
          });
      })
        var lazyloadImages;    

        lazyloadImages = document.querySelectorAll(".lazy");
        var imageObserver = new IntersectionObserver (function (entries, observer) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var image = entry.target;
              image.src = image.dataset.src;
              image.classList.remove("lazy");
              imageObserver.unobserve(image);
            }
          });
          
        });

        lazyloadImages.forEach(function(image) {
          imageObserver.observe(image);
        });
      window.mobileCheck = function() {
          let check = false;
        
          check = ( ( window.innerWidth <= 800 ) );
          
          return check;
          };

          function detectUserInteraction(){
              document.getElementsByTagName('html')[0].classList.add('js-user-action');

              'keydown mouseover touchmove touchstart wheel'.split(" ").forEach(function(e){
                  window.removeEventListener(e,detectUserInteraction,false);
              });
          }

          if( window.mobileCheck() ){

              'keydown mouseover touchmove touchstart wheel'.split(" ").forEach(function(e){
                  window.addEventListener(e,detectUserInteraction,false);
              });
          }else{
              document.getElementsByTagName('html')[0].classList.add('js-user-action');
          }
(function ($) {
    function delay(callback, ms) {
        var timer = 0;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    $('.auto-search').keyup(delay(function (e) {

        var container = $(this).closest('.searchBox');
        var q = container.find('input[type=text]').val();
        if (q.length < 3) {
            return false;
        }
        $.ajax('/quicksearch/auto/?q=' + q, {
            beforeSend: function (xhr) {
                //$('.loader').removeClass('hidden');
            }
        })
            .done(function (response) {
                container.find('.results').html(response).removeClass('hidden');
                // Screenreader über Suchergebnisse informieren
                var liveRegion = document.getElementById('a11y-search-status');
                if (!liveRegion) {
                    liveRegion = document.createElement('div');
                    liveRegion.id = 'a11y-search-status';
                    liveRegion.setAttribute('role', 'status');
                    liveRegion.setAttribute('aria-live', 'polite');
                    liveRegion.className = 'visually-hidden';
                    document.body.appendChild(liveRegion);
                }
                var count = container.find('.results').children().length;
                liveRegion.textContent = count > 0 ? count + ' Suchergebnisse gefunden' : 'Keine Ergebnisse gefunden';
            })
            .fail(function (xhr) {
                console.error('Error: ' + xhr.responseText);
            })
            .always(function () {
                $('.loader').addClass('hidden');
            })
        ;

    }, 400));


    var clicky;

    $(document).on('mousedown touchstart', function(e) {
        // The latest element clicked
        clicky = $(e.target);
    });

    // when 'clicky == null' on blur, we know it was not caused by a click
    // but maybe by pressing the tab key
    $(document).on('mouseup touchend',function(e) {
        clicky = null;
    });
    
    $('.auto-search')
        .blur(function (e) {
           
           
            var target = clicky; //target div recorded
            
            var $wrapper = $('.results'),
                $target = clicky;

            if($.contains($wrapper[0], $target[0])){
                e.stopPropagation();
            }else{
                $('.results').hide(); //if the click element is not the above id will hide
            }   
        })
        .focusin(function (e) {
            $('.results').show();
        });
   

        $(document).ready(function(){

            // Neues Zweispalten-Design (dialog#cr_embeded_form): siehe
            // themes/au23/templates/Includes/NewsletterElement.ss und
            // themes/au23/css/newsletter-popup.css. Nutzt das native <dialog>-Element
            // (showModal/close) mit Fallback auf das alte Show/Hide-Verhalten fuer
            // Browser ohne showModal-Unterstuetzung (z. B. iOS Safari < 15.4).
            var $newsletterDialog = $('#cr_embeded_form');
            var newsletterDialogEl = $newsletterDialog.get(0);
            var supportsNativeDialog = !!(newsletterDialogEl && typeof newsletterDialogEl.showModal === 'function');
            var newsletterOpen = false;
            var newsletterPreviousOverflow = '';

            function openNewsletterPopup() {
                if (!newsletterDialogEl || newsletterOpen) return;
                newsletterOpen = true;
                newsletterPreviousOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
                if (supportsNativeDialog) {
                    newsletterDialogEl.showModal();
                } else {
                    // Fallback ohne native Dialog-Semantik: nur per CSS zentriert anzeigen,
                    // kein abgedunkelter Hintergrund (::backdrop greift nur im Top-Layer).
                    $newsletterDialog.show();
                }
                var $title = $('#cr_newsletter_title');
                if ($title.length) $title.attr('tabindex', '-1').trigger('focus');
            }

            function closeNewsletterPopup() {
                if (!newsletterDialogEl || !newsletterOpen) return;
                newsletterOpen = false;
                document.body.style.overflow = newsletterPreviousOverflow;
                if (supportsNativeDialog && newsletterDialogEl.open) {
                    newsletterDialogEl.close();
                } else {
                    $newsletterDialog.hide();
                }
                // Cookie-Sperre: 7 Tage, damit das Popup nach dem Schliessen nicht in jeder
                // neuen Browser-Sitzung erneut erscheint (siehe setCookie()-Aufruf unten).
                setCookie('Newsletter', 1, 7);
            }

            if(!getCookie('Newsletter') && newsletterDialogEl){
                // Newsletter-Popup nur anzeigen, wenn Nutzer prefers-reduced-motion nicht aktiviert hat
                var delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 20000;
                setTimeout(openNewsletterPopup, delay);
            }

            $("#cr_embed_close_form").on('click', closeNewsletterPopup);
            $("#cr_newsletter_decline").on('click', closeNewsletterPopup);

            // Native Escape-Behandlung bei showModal() abfangen, damit auch dieser Weg
            // konsistent das Cookie setzt (statt der Browser-eigenen Standardschliessung).
            if (newsletterDialogEl) {
                newsletterDialogEl.addEventListener('cancel', function(e){
                    e.preventDefault();
                    closeNewsletterPopup();
                });
            }
            // Escape schließt Newsletter-Popup (Fallback-Pfad ohne native Dialog-Semantik)
            $(document).on('keydown', function(e) {
                if (e.key === 'Escape' && newsletterOpen && !supportsNativeDialog) {
                    closeNewsletterPopup();
                }
            });
            // Klick auf den Hintergrund schliesst das Popup (Pointerdown-Start ausserhalb
            // verhindert, dass ein Drag/Select, das im Popup beginnt, es versehentlich schliesst).
            var newsletterPointerStartedOutside = false;
            function isOutsideNewsletterPopup(event) {
                if (!newsletterDialogEl) return false;
                var r = newsletterDialogEl.getBoundingClientRect();
                return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
            }
            if (newsletterDialogEl) {
                newsletterDialogEl.addEventListener('pointerdown', function(e){
                    newsletterPointerStartedOutside = isOutsideNewsletterPopup(e);
                });
                newsletterDialogEl.addEventListener('click', function(e){
                    if (e.target === newsletterDialogEl && newsletterPointerStartedOutside && isOutsideNewsletterPopup(e)) {
                        closeNewsletterPopup();
                    }
                    newsletterPointerStartedOutside = false;
                });
            }

            // E-Mail-Validierung + Bestaetigungsansicht. Bei gueltiger Eingabe wird
            // event.preventDefault() NICHT aufgerufen: das Formular sendet weiterhin NATIV
            // (kein AJAX) per target in ein verstecktes iframe ("cr_popup_iframe"), damit der
            // CleverReach-Flow-"/confirm"-Endpoint eine echte Navigation sieht und den
            // Double-Opt-In ausloest -- nur eben unsichtbar, statt in einem neuen Tab.
            $("#cr_newsletter_form").on('submit', function(event){
                var $form = $(this);
                var $email = $('#cr_newsletter_email');
                var $error = $('#cr_newsletter_email_error');
                $email.val($.trim($email.val()));

                if (!this.checkValidity || !this.checkValidity()) {
                    event.preventDefault();
                    var missing = $email.val() === '';
                    $error.text(missing ? 'Bitte geben Sie Ihre E-Mail-Adresse ein.' : 'Bitte prüfen Sie Ihre E-Mail-Adresse.').prop('hidden', false);
                    $email.attr('aria-invalid', 'true').trigger('focus');
                    return;
                }

                $email.removeAttr('aria-invalid');
                $error.prop('hidden', true);
                setCookie('Newsletter', 1, 7);

                // Signup-Ansicht gegen die Bestaetigungsansicht tauschen (gleicher Dialog).
                $('#cr_newsletter_signup').prop('hidden', true);
                var $nextStep = $('#cr_newsletter_next_step');
                $nextStep.prop('hidden', false);
                $nextStep.attr('tabindex', '-1').trigger('focus');
                // Popup 6 Sekunden nach Anzeige der Bestaetigung automatisch schließen
                setTimeout(closeNewsletterPopup, 6000);
            });
            $('#cr_newsletter_email').on('input', function(){
                $(this).removeAttr('aria-invalid');
                $('#cr_newsletter_email_error').prop('hidden', true);
            });
        });

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
       

     

})(jQuery);
document.addEventListener('DOMContentLoaded', function () {

  // 1. Externe Links (target="_blank"): Hinweis als visually-hidden Span
  document.querySelectorAll('a[target="_blank"]').forEach(function(link) {
    if (link.querySelector('.visually-hidden')) return;

    // rel="noopener noreferrer" ergänzen
    var rel = link.getAttribute('rel') || '';
    if (rel.indexOf('noopener') === -1) {
      link.setAttribute('rel', 'noopener noreferrer');
    }

    // Zusatzinfo als visually-hidden Span (überschreibt NICHT den sichtbaren Text)
    var hint = document.createElement('span');
    hint.className = 'visually-hidden';
    hint.textContent = ' (öffnet in neuem Tab)';
    link.appendChild(hint);
  });

  // 2. CMS-Content-Links ohne Text: Fallback-Linktext setzen
  var contentArea = document.querySelector('#main-content, main, [role="main"]');
  if (contentArea) {
    contentArea.querySelectorAll('a').forEach(function(link) {
      var linkText = link.textContent.trim();
      var hasImage = link.querySelector('img[alt]');
      var hasAriaLabel = link.hasAttribute('aria-label');

      if (!linkText && !hasImage && !hasAriaLabel) {
        var href = link.getAttribute('href') || '';
        var fallback = href.indexOf('mailto:') === 0 ? 'E-Mail senden'
                     : href.indexOf('tel:') === 0 ? 'Anrufen'
                     : 'Mehr erfahren';

        var srText = document.createElement('span');
        srText.className = 'visually-hidden';
        srText.textContent = fallback;
        link.appendChild(srText);
      }
    });
  }

});
function adjustAllImageHeights() {
    var wrappers = document.querySelectorAll('.TextBildBlock, .ContactFormBlock');

    // Nur ausführen, wenn Fensterbreite >= 768px
    if (window.innerWidth >= 768) {
        wrappers.forEach(function (wrapper) {
            var textCol = wrapper.querySelector('.text-col');
            var imageCol = wrapper.querySelector('.bild-col');

            if (textCol && imageCol) {
                var textOffsetHeight = textCol.offsetHeight;
                imageCol.style.height = textOffsetHeight + 'px';
            }
        });
    } else {
        // Auf kleineren Screens Höhe zurücksetzen (automatisch)
        wrappers.forEach(function (wrapper) {
            var imageCol = wrapper.querySelector('.bild-col');
            if (imageCol) {
                imageCol.style.height = 'auto';
            }
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".reisenliste__imgSwitch").forEach(function (switcher) {
        switcher.querySelectorAll("[data-modus]").forEach(function (btn) {
            btn.addEventListener("click", function () {
                const modus = btn.getAttribute("data-modus");
                const teaser = btn.closest(".special-image-container");

                // Schalter-Status aktualisieren
                switcher.querySelectorAll("[data-modus]").forEach(b => b.classList.remove("imgSwitch--active"));
                btn.classList.add("imgSwitch--active");

                // Bild/Karte sichtbar schalten
                teaser.querySelectorAll("[data-bildmodus]").forEach(el => {
                    const show = el.getAttribute("data-bildmodus") === modus;
                    el.classList.toggle("d-none", !show);
                });
            });
        });
    });
});

window.addEventListener('DOMContentLoaded', function() {
  adjustAllImageHeights();
});

window.addEventListener('load', function() {
  adjustAllImageHeights();
});

window.addEventListener('resize', function() {
  adjustAllImageHeights();
});
  